export default __webpack_public_path__ + "static/image1-faa6f055ecd9142101df34dab0948e51.png";